import { extendTheme, theme } from "@chakra-ui/react";

import iloqTheme from "@iloqshared/design-tokens/dist/theme";

export default extendTheme({
  ...iloqTheme,
  components: {
    Input: {
      defaultProps: {
        size: "lg",
      },
    },
    Select: {
      defaultProps: {
        size: "lg",
      },
    },
    Heading: {
      baseStyle: {
        lineHeight: "1.2",
        fontWeight: "normal",
      },
    },
    Button: {
      variants: {
        pill: (props: any) => ({
          ...theme.components.Button.variants!.solid(props),
          borderRadius: "full",
        }),
        beigePill: (props: any) => ({
          ...theme.components.Button.variants!.solid(props),
          borderRadius: "full",
          color: "brand.purple",
          background: "brand.beige",
          borderColor: "brand.beige",
          cursor: "pointer",
          _hover: {
            ...theme.components.Button.variants!.solid(props)._hover,
            background: "brand.beigeLight",
            color: "brand.purple",
          },
          _active: {
            ...theme.components.Button.variants!.solid(props)._active,
            background: "brand.beigeDark",
            color: "brand.purple",
          },
        }),
        partnerLink: (props: any) => ({
          ...theme.components.Button.variants!.ghost(props),
          borderRadius: "full",
          color: "brand.purple",
          cursor: "pointer",
          _hover: {
            ...theme.components.Button.variants!.solid(props)._hover,
            background: "brand.beigeLight",
            borderColor: "brand.beigeLight",
            color: "brand.purple",
            textDecoration: "none",
          },
          _active: {
            ...theme.components.Button.variants!.solid(props)._active,
            background: "brand.beigeDark",
            borderColor: "brand.beigeDark",
            color: "brand.purple",
          },
        }),
      },
    },
    Switch: {
      variants: {
        purpleDark: {
          track: {
            bg: "brand.grayDark",
            _checked: {
              bg: "brand.purple",
            },
          },
          thumb: {
            bg: "white",
          },
        },
      },
    },
    Tabs: {
      variants: {
        purpleDark: {
          tab: {
            _selected: {
              bg: "#0D0F22",
              color: "white",
            },
            color: "#333333",
            bg: "transparent",
            borderRadius: "full",
            padding: "12px 40px",
          },
          tabpanel: {
            paddingX: 0,
          },
        },
      },
    },
    Form: {
      baseStyle: (props: { isInvalid: boolean }) => ({
        requiredIndicator: {
          color: props.isInvalid ? "red.500" : "black",
        },
      }),
    },
  },
  styles: {
    global: {
      body: {
        background: "gray.50",
        "@media print": {
          background: "white",
        },
      },
    },
  },
});
